<div #datepickerModal class="wrapper-modal datepicker-insights">
  <div class="wrapper-modal-content">
    <div class="wrapper-custom-datepicker">
      <div class="custom-datepicker">
        <div class="label-selected">
          <span *ngIf="selectedDate">{{selectedDate | dateRange: selectedFilter}}</span>
        </div>
        <div class="datepicker-tabs">
          <div *ngFor="let filter of listOfFilters" (click)="selectedFilter = filter" class="datepicker-tab" [ngClass]="{'active': filter === selectedFilter}">
            <span>{{filter}}</span>
          </div>
        </div>
        <mat-calendar [selected]="selectedCalendarDate" [maxDate]="maxDate" (selectedChange)="onDateChange($event)"></mat-calendar>
        <div class="wrapper-insights-modal-button">
          <button class="custom-btn custom-btn--outline" (click)="closeModal.emit()"><span> {{'NEW_TEXT.cancel' | translate}}</span></button>
          <button class="custom-btn custom-btn--primary" (click)="confirmSelectedDate.emit({selectedDate, selectedFilter})"><span> {{'NEW_TEXT.update' | translate}}</span></button>
        </div>
      </div>
    </div>
  </div>
</div>


